import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';

import { makeStyles } from '@material-ui/core/styles';

import './loader.styles.scss';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: 'transparent',
        borderColor:'transparent',
        outline:'none'
    },
}))
export const Loader = (props) => {
    const classes = useStyles();
    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={props.flag}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                className="modal-background"
            >
                {/* <Fade in={props.flag}> */}
                    <div className={classes.paper}>
                        {/* <CircularProgress /> */}
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} className='loaderImage'/>
                    </div>
                {/* </Fade> */}
            </Modal>
        </>
    )
}